import { useEffect } from "react";
import { DefaultLayout } from "src/layouts/DefaultLayout";
import { GuardAuthenticated } from "src/components/GuardAuthenticated";
import { GroupVideosList } from "src/components/GroupVideosList";
import { useAuth } from "src/hooks/useAuth";
import { useUserCards } from "src/hooks/useUserCards";
import { LoadingStatus } from "src/libs/fetcher";
import { toastError } from "src/libs/toast-lib";
import { useContributorCards } from "src/hooks/useContributorCards";

// this is in its own component because we don't want to run the queries until
// the GuardAuthenticated check is done.
function PageContent() {
  const { isLoggedIn } = useAuth();
  const { cards, error, status, mutate } = useUserCards();
  const contributorCardsResult = useContributorCards();
  const contributorCards = contributorCardsResult.cards || [];
  const userCards = cards || [];

  useEffect(() => {
    if (status === LoadingStatus.ERROR) {
      const message =
        error instanceof Error
          ? error.message
          : error
            ? error
            : "Something went wrong and your group videos could not be loaded.";

      toastError(message);
    }
  }, [status]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    mutate();
  }, [isLoggedIn]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <GroupVideosList
      cards={userCards}
      contributorCards={contributorCards}
      isLoading={status === LoadingStatus.LOADING}
    />
  );
}

export default function GroupVideosPage() {
  return (
    <GuardAuthenticated redirect="/group-videos/new">
      <DefaultLayout>
        <PageContent />
      </DefaultLayout>
    </GuardAuthenticated>
  );
}

GroupVideosPage.enableSessionRecording = true;
